import { render, staticRenderFns } from "./dados-basicos.vue?vue&type=template&id=e4e5f8bc"
import script from "./dados-basicos.vue?vue&type=script&lang=js"
export * from "./dados-basicos.vue?vue&type=script&lang=js"
import style0 from "./dados-basicos.vue?vue&type=style&index=0&id=e4e5f8bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports